var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZenkiLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 71,
    viewBox: "0 0 133 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_60_352",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 71
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 71,
    fill: "#DBC0C0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_60_352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.161 50.1554H97.2436L90.8862 40.8333H90.7692V50.1554H84.3338V20.6682H90.7692V38.6101H90.8862L97.0876 30.7313H104.849L97.3606 39.5072L105.161 50.1554V50.1554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.262 30.7261H105.866V50.1502H112.262V30.7261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.064 27.8244C111.234 27.8244 112.993 26.0656 112.993 23.8959C112.993 21.7263 111.234 19.9674 109.064 19.9674C106.895 19.9674 105.136 21.7263 105.136 23.8959C105.136 26.0656 106.895 27.8244 109.064 27.8244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9665 38.6256L69.9664 50.1542H63.5737V38.5954C63.6036 33.3253 67.8914 30.2396 73.1683 30.2396C78.4451 30.2396 82.7627 32.8754 82.7627 38.5895L82.7629 50.1542H76.3701V38.6463C76.3701 36.879 74.9354 35.4443 73.1683 35.4443C71.408 35.4443 69.9776 36.8679 69.9665 38.6256L69.9665 38.6256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3284 47.1527C42.8127 45.3541 41.8989 43.0318 41.8989 40.4978C41.8989 34.7932 46.5301 30.1617 52.2345 30.1617C57.9389 30.1617 62.5701 34.7932 62.5701 40.4978C62.5701 41.0961 62.5192 41.6825 62.4213 42.2536L48.2999 42.2541C48.5425 44.5274 49.7623 46.0421 52.4992 46.0421C54.2824 46.0421 55.202 45.348 55.9676 44.2032L61.6209 45.5796C59.8582 48.7609 56.1262 50.8339 52.2344 50.8339C49.4685 50.8339 46.9549 49.745 45.0992 47.9729C45.7165 46.6757 45.895 44.8621 45.895 44.8621L45.8941 44.863C45.8561 45.0254 45.7882 45.1823 45.6905 45.3252C45.2634 45.9531 44.8094 46.5659 44.3284 47.1527H44.3284ZM56.4771 37.4052C55.9349 35.6289 54.7903 34.4832 52.4993 34.4832C50.0944 34.4832 48.9585 35.6527 48.4497 37.4789C48.3746 37.7338 48.3237 37.9987 48.2998 38.2713H56.6495L56.6495 38.2712H56.6532C56.6452 38.1984 56.6357 38.1263 56.6247 38.0552C56.5931 37.8323 56.5434 37.6151 56.4771 37.4052V37.4052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4981 24.0401C44.4863 24.1952 45.3145 24.8705 45.6654 25.8073C46.0164 26.7441 45.8358 27.7973 45.1927 28.5636C40.5138 34.1409 32.1275 44.135 32.1275 44.135C36.0457 44.3537 40.1892 43.8867 44.3296 43.1923C44.8731 43.102 45.4181 43.3448 45.7145 43.8093C46.0108 44.2738 46.0014 44.8704 45.6904 45.3253C44.4488 47.1506 42.9804 48.8482 41.2779 50.1514C40.9186 50.4269 40.4882 50.5941 40.0372 50.6334C34.0498 51.1434 28.2679 50.7657 22.4323 49.8374C21.444 49.6823 20.6159 49.007 20.2649 48.0702C19.914 47.1334 20.0946 46.0802 20.7376 45.3139C25.4166 39.7365 33.8028 29.7425 33.8028 29.7425C29.8847 29.5238 25.7411 29.9908 21.6007 30.6851C21.0572 30.7755 20.5122 30.5327 20.2159 30.0681C19.9195 29.6036 19.929 29.0071 20.2399 28.5522C21.4816 26.7268 22.9499 25.0292 24.6525 23.726C25.0117 23.4505 25.4422 23.2833 25.8932 23.2441C31.8806 22.7341 37.6624 23.1118 43.498 24.0401H43.4981Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenkiLogoWhite);
export default __webpack_public_path__ + "static/media/zenki_logo_white.704b4f9764c836801af7b1980e2d8cbc.svg";
export { ForwardRef as ReactComponent };